import React from "react";
import { Dropdown } from "react-bootstrap";
import Logout from "../../pages/Authintication/Logout";
import { useDispatch, useSelector } from "react-redux";
import { setLang, setSearch } from "../../../store/actions/AuthActions";
import { Translate } from "../../Enums/Tranlate";
import usa from "../../../images/usa.svg";
import kwait from "../../../images/kwait.svg";

const Header = () => {
	const dispatch = useDispatch();
	const lang = useSelector((state) => state.auth.lang);
	const search = useSelector((state) => state.auth.search);
	const admin = useSelector((state) => state.auth.auth.admin);

	return (
		<div className="header">
			<div className="header-content">
				<nav className="navbar navbar-expand">
					<div className="collapse navbar-collapse justify-content-between">
						<div className="header-left">
							<div className="input-group">
								<input
									type="text"
									className="form-control"
									placeholder={Translate[lang]?.search}
									value={search}
									onChange={(e) => dispatch(setSearch(e.target.value))}
								/>
								<div
									className="flaticon-381-search-2"
									style={{
										position: "absolute",
										zIndex: "3",
										left: lang === "en" && "16px",
										right: lang === "ar" && "16px",
										top: "50%",
										transform: "translate(0, -50%)",
									}}></div>
							</div>
						</div>
						<ul className="navbar-nav header-right p-0">
							{/* Notification */}
							{/* <Dropdown
								as="li"
								className="nav-item dropdown notification_dropdown ">
								<Dropdown.Toggle
									variant=""
									className="nav-link ai-icon"
									href="#"
									role="button"
									style={{
										background: "none",
									}}
									data-toggle="dropdown">
									<svg
										width="32"
										height="32"
										viewBox="0 0 32 32"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M16.0267 3.88022C11.6133 3.88022 8.02666 7.46689 8.02666 11.8802V15.7336C8.02666 16.5469 7.67999 17.7869 7.26666 18.4802L5.73333 21.0269C4.78666 22.6002 5.44 24.3469 7.17333 24.9336C12.92 26.8536 19.12 26.8536 24.8667 24.9336C26.48 24.4002 27.1867 22.4936 26.3067 21.0269L24.7733 18.4802C24.3733 17.7869 24.0267 16.5469 24.0267 15.7336V11.8802C24.0267 7.48022 20.4267 3.88022 16.0267 3.88022Z"
											stroke="#7B7B7B"
											strokeWidth="2"
											strokeMiterlimit="10"
											strokeLinecap="round"
										/>
										<path
											d="M18.4934 4.26658C18.0801 4.14658 17.6534 4.05325 17.2134 3.99991C15.9334 3.83991 14.7067 3.93325 13.5601 4.26658C13.9467 3.27991 14.9067 2.58658 16.0267 2.58658C17.1467 2.58658 18.1067 3.27991 18.4934 4.26658Z"
											stroke="#7B7B7B"
											strokeWidth="2"
											strokeMiterlimit="10"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
										<path
											d="M20.0267 25.4134C20.0267 27.6134 18.2267 29.4134 16.0267 29.4134C14.9334 29.4134 13.9201 28.9601 13.2001 28.2401C12.4801 27.5201 12.0267 26.5068 12.0267 25.4134"
											stroke="#7B7B7B"
											strokeWidth="2"
											strokeMiterlimit="10"
										/>
									</svg>
								</Dropdown.Toggle>

								<Dropdown.Menu align="right" className="mt-2 custom-dropdown">
									<ul className="timeline text-center">
										<li
											className="py-2"
											style={{
												backgroundColor:
													lang === "en" ? "var(--bg-primary)" : "#fff",
												color: lang === "en" ? "var(--primary)" : "#000",
												cursor: "pointer",
											}}
											onClick={() => {}}></li>
									</ul>
								</Dropdown.Menu>
							</Dropdown> */}
							<Dropdown
								as="li"
								className="nav-item dropdown notification_dropdown px-2">
								<Dropdown.Toggle
									variant=""
									className="nav-link ai-icon"
									href="#"
									role="button"
									style={{
										background: "none",
									}}
									data-toggle="dropdown">
									<img
										src={lang === "en" ? usa : kwait}
										width={25}
										alt="language"
									/>{" "}
									<i
										className="la la-angle-down mx-2"
										style={{ fontSize: "16px" }}></i>
								</Dropdown.Toggle>

								<Dropdown.Menu align="right" className="mt-2 custom-dropdown">
									<ul className="timeline text-center">
										<li
											className="py-2"
											style={{
												backgroundColor:
													lang === "en" ? "var(--bg-primary)" : "#fff",
												color: lang === "en" ? "var(--primary)" : "#000",
												cursor: "pointer",
											}}
											onClick={() => dispatch(setLang("en"))}>
											English
										</li>
										<li
											className="py-2"
											style={{
												backgroundColor:
													lang === "ar" ? "var(--bg-primary)" : "#fff",
												color: lang === "ar" ? "var(--primary)" : "#000",
												cursor: "pointer",
												fontFamily: "Cairo",
											}}
											onClick={() => dispatch(setLang("ar"))}>
											اللغه العربيه
										</li>
									</ul>
								</Dropdown.Menu>
							</Dropdown>

							<Dropdown
								as="li"
								className="nav-item dropdown p-0 header-profile">
								<Dropdown.Toggle
									variant=""
									as="a"
									className="nav-link i-false"
									style={{
										background: "none",
										cursor: "pointer",
									}}>
									{!!admin?.avatar ? (
										<img
											src={admin?.avatar}
											width={40}
											alt="user"
											className="mx-2"
											style={{
												borderRadius: "50%",
											}}
										/>
									) : (
										<i
											className="la la-user mx-2"
											style={{
												fontSize: "32px",
												color: "var(--primary)",
												border: "1px solid var(--primary)",
												borderRadius: "50%",
											}}></i>
									)}
									<span style={{ fontSize: "14px" }}>{admin?.f_name}</span>
									<i
										className="la la-angle-down mx-2"
										style={{ fontSize: "16px" }}></i>
								</Dropdown.Toggle>

								<Dropdown.Menu align="right" className="mt-2 custom-dropdown">
									{/* <Link to="/profile" className="dropdown-item ai-icon">
										<svg
											id="icon-user1"
											xmlns="http://www.w3.org/2000/svg"
											className="text-primary"
											width={18}
											height={18}
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											strokeWidth={2}
											strokeLinecap="round"
											strokeLinejoin="round">
											<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
											<circle cx={12} cy={7} r={4} />
										</svg>
										<span className={lang === "en" ? "ml-2" : "mr-2"}>
											{Translate[lang]?.profile}{" "}
										</span>
									</Link> */}
									<Logout />
								</Dropdown.Menu>
							</Dropdown>
						</ul>
					</div>
				</nav>
			</div>
		</div>
	);
};

export default Header;
